import { ButtonColor } from "@/common/enum/button-color";
import { Breadcrumb, Button } from "flowbite-react";
import React from "react";
import { H4 } from "../typography/H4";

interface Props {
  isActive: boolean;
  handleOpenCreateItemModal: () => void;
}

export const ItemCreateHeader: React.FC<Props> = ({
  isActive,
  handleOpenCreateItemModal,
}) => {
  return (
    <div className="flex flex-col mb-[32px]">
      <Breadcrumb>
        <Breadcrumb.Item>상품 관리</Breadcrumb.Item>
        <Breadcrumb.Item>상품 관리</Breadcrumb.Item>
        <Breadcrumb.Item>상품 등록</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between">
        <H4 className="text-semantic-text-heading">상품 등록</H4>
        <Button
          color={isActive ? ButtonColor.PRIMARY : ""}
          onClick={handleOpenCreateItemModal}
          disabled={!isActive}
        >
          상품 등록
        </Button>
      </div>
    </div>
  );
};
